import { FastFilters } from '../fast_filters';

export function init(fastFilters: FastFilters) {
  const container = document.querySelector('[data-mark=withPhoto]');

  if (!container) {
    return () => [];
  }

  const span = container.querySelector('span');

  if (!span) {
    return () => [];
  }

  const className = '_2TXtVIdi1LdzA7au';

  const spanClickListener = () => {
    if (fastFilters.isWithPhotoEnabled()) {
      fastFilters.setWithPhoto(false);
      span.classList.remove(className);
    } else {
      fastFilters.setWithPhoto(true);
      span.classList.add(className);
    }
  };

  span.addEventListener('click', spanClickListener);

  return () => {
    span.removeEventListener('click', spanClickListener);
  };
}
